export default "__VITE_ASSET__C4ESX9Oz__"